import { ContactCategoryService } from './contact-category.service';
import { ContactGroupService } from './contact-group.service';

export const contactCategoryService = new ContactCategoryService();
export const contactGroupService = new ContactGroupService();
